import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'track', 'knob']

  connect() {
    this.updateVisual()
  }

  toggle() {
    this.updateVisual()
  }

  updateVisual() {
    const isChecked = this.checkboxTarget.checked

    if (isChecked) {
      this.trackTarget.style.background = '#FFDE45'
      this.knobTarget.style.transform = 'translateX(20px)'
    } else {
      this.trackTarget.style.background = '#D1D5DB'
      this.knobTarget.style.transform = 'translateX(0)'
    }
  }
}
